<template>
    <section class="onboarding-de onboarding-type-a">
        <div class="container">
            <form id="onboarding-de" class="wrapper wrapper-tab-last" role="form" method="post" @submit.prevent="submitReason">
                <header>
                    <span class="new-headline-xlg text-centered">{{ __('Your unsubscription has been successful.') }}</span>
                    <p v-if="!resubscribed" class="new-text-lg text-centered">{{ __('Did you log out by mistake?') }} <strong><a href="#" class="text-violet" @click.prevent="resubscribe">{{ __('Sign in again here.') }}</a></strong></p>
                    <div v-else class="new-text-lg text-bold text-centered text-green text-success">
                        <v-button :label="__('Back to main page')" href="/" position="center"></v-button>
                    </div>
                </header>
                
                <div class="form-input-radio-button-wrapper" v-if="!resubscribed">
                    <p class="new-text-xl text-bold text-centered">{{ __('We are sorry to see you leave. If you have a moment, please tell us why you unsubscribed.') }}</p>

                    <form-input-type-radio-button
                        v-for="(item, index) in survey"
                        :key="index"
                        :value="item.label"
                        :text-input="item.textInput"
                        :errors="errors.reason"
                        @onClick="chooseSurvey(item.label)"
                    ></form-input-type-radio-button>
                </div>                
            </form>
        </div>

        <flash-alert v-if="resubscribed" @closeAlert="close" position="top" :text="__('Thank you for your time!')"></flash-alert>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                choosenSurvey: null,
                resubscribed: false,
                token: null,
                errors: [],
                survey: [
                    {label: this.__("Not interested in the emails")},
                    {label: this.__("Too many emails")},
                    {label: this.__("It bothers me")},
                    {label: this.__("It's spam I never agreed to")},
                    {label: this.__("Other reasons"), textInput: this.__("Please describe your reason")},
                ],
            }
        },

        mounted() {
            let uri = new URI(location.href)

            let token = uri.pathname().replace("/mailing-info/", "")
            this.token = token.replace("/unsubscribe", "")
        },

        methods: {
            chooseSurvey(reason) {
                this.choosenSurvey = reason

                if(reason !== this.__("Other reasons")) {
                    this.submitReason()
                }
            },
            submitReason() {
                var formData = {}

                if(this.choosenSurvey === this.__("Other reasons")) {
                    formData.reason = $('.form-input-radio-button #text').val()
                } else {
                    formData.reason = this.choosenSurvey
                }

                axios
                    .post('/mailing-info/'+this.token+'/unsubscribe-reason', formData, {
                        headers: {
                            'Accept-Language': this.locale
                        }
                    })
                    .then((e) => {
                        $('#modal-success').modal('show')
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            resubscribe() {
                axios
                    .post('/mailing-info/'+this.token+'/resubscribe', {
                        headers: {
                            'Accept-Language': this.locale
                        }
                        
                    })
                    .then((e) => {
                        this.resubscribed = true
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            }
        }
    }
</script>